import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../reducers";
import { PillButton, PillButtonArrow } from "./styles";
import FilterArrow from "../../assets/filter_arrow.svg";
import FilterArrowDark from "../../assets/filter_arrow_dark.svg";

interface Props {
  title: string;
  data: string | null;
}

function Pill({ title, data }: Props) {
  const dispatch = useDispatch();
  const filterStore = useSelector((state: RootState) => state.filter);
  const activeFilter = filterStore.selectedFilter === title;

  return (
    <PillButton
      role="button"
      active={activeFilter}
      onClick={() => {
        dispatch({
          type: "SET_SELECTED_FILTER",
          payload: title !== filterStore.selectedFilter ? title : "",
        });
      }}
    >
      {data}
      <PillButtonArrow active={activeFilter}>
        <img
          src={
            filterStore.selectedFilter === title ? FilterArrow : FilterArrowDark
          }
          alt="filter arrow icon"
        />
      </PillButtonArrow>
    </PillButton>
  );
}

export default Pill;
